// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Co-z","badgeLink":"Do-z","category":"Eo-z"};